import type { PixelRect } from "@/home/sheet-crop";

export function maxSquareCropRect(imageWidth: number, imageHeight: number): PixelRect {
  const iw = Math.max(1, imageWidth);
  const ih = Math.max(1, imageHeight);
  const side = Math.min(iw, ih);
  return {
    sx: (iw - side) / 2,
    sy: (ih - side) / 2,
    sw: side,
    sh: side,
  };
}

export function clampSquareCropRect(
  rect: PixelRect,
  imageWidth: number,
  imageHeight: number,
): PixelRect {
  const iw = Math.max(1, imageWidth);
  const ih = Math.max(1, imageHeight);
  const side = Math.min(Math.max(8, rect.sw, rect.sh), iw, ih);
  const sx = Math.min(Math.max(0, rect.sx), iw - side);
  const sy = Math.min(Math.max(0, rect.sy), ih - side);
  return { sx, sy, sw: side, sh: side };
}

export function exportPetFrameCrop(
  image: HTMLImageElement,
  rect: PixelRect,
  frameWidth: number,
  frameHeight: number,
): string {
  const canvas = document.createElement("canvas");
  canvas.width = frameWidth;
  canvas.height = frameHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("crop ภาพไม่สำเร็จ");
  }
  ctx.clearRect(0, 0, frameWidth, frameHeight);

  const scale = Math.min(frameWidth / rect.sw, frameHeight / rect.sh);
  const dw = rect.sw * scale;
  const dh = rect.sh * scale;
  const dx = (frameWidth - dw) / 2;
  const dy = frameHeight - dh;
  ctx.drawImage(image, rect.sx, rect.sy, rect.sw, rect.sh, dx, dy, dw, dh);
  return canvas.toDataURL("image/png");
}
